import { useContext, useState } from "react";
import UserContext from "../context/UserContext";
import "../css/LoginPage.css";
import { useDebouncedCallback } from "use-debounce";

function LoginPage() {
  const { login, loading, error } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const debouncedSetUsername = useDebouncedCallback(
    (value) => setUsername(value),
    200
  );

  const debouncedSetPassword = useDebouncedCallback(
    (value) => setPassword(value),
    200
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login({ username, password });
  };

  return (
    <div className="login">
      <h1>Login</h1>
      <form onSubmit={handleSubmit}>
        <div className="box">
          <input
            type="text"
            required
            onChange={(e) => debouncedSetUsername(e.target.value)}
            disabled={loading}
          />
          <span>Username</span>
        </div>
        <div className="box">
          <input
            type="password"
            required
            onChange={(e) => debouncedSetPassword(e.target.value)}
            disabled={loading}
          />
          <span>Password</span>
        </div>
        {error && <span className="text-danger">{error}</span>}
        <div className="box text-center">
          <button type="submit" disabled={loading}>
            {loading ? "Connexion..." : "Login"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginPage;
